module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-583.26e68655.jpg";